// src/components/pages/PrivacyPolicyPage.js
import React from "react";
import "../../styles/legal.css";
import { Helmet } from "react-helmet-async";

export default function PrivacyPolicyPage() {
  return (
    <>
    <Helmet>
  <title>Privacy Policy – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Read the PracVerse Privacy Policy to understand how we collect, use and protect your data when you use our website and services."
  />
  <link rel="canonical" href="https://www.pracverse.com/privacy-policy" />

  <meta property="og:title" content="Privacy Policy – PracVerse" />
  <meta
    property="og:description"
    content="Information on how PracVerse handles your personal data and privacy."
  />
  <meta property="og:url" content="https://www.pracverse.com/privacy-policy" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Privacy Policy – PracVerse",
      "url": "https://www.pracverse.com/privacy-policy",
      "about": "Privacy Policy"
    })}
  </script>
</Helmet>

    <main className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: 30 November 2025</p>
          <p >
            This Privacy Policy explains how PracVerse (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;) collects,
            uses, and protects your information when you use our website, courses,
            and services.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <h2>1. Information We Collect</h2>
          <h3>1.1 Information you provide directly</h3>
          <ul>
            <li>Name, email address, phone number</li>
            <li>School / organisation name and role</li>
            <li>Messages sent through forms or email</li>
            <li>Workshop or program enrollment details</li>
          </ul>

          <h3>1.2 Information collected automatically</h3>
          <p>When you use our website, we may automatically collect:</p>
          <ul>
            <li>IP address, browser type and device information</li>
            <li>Pages visited, time spent and click data</li>
            <li>General usage analytics through cookies and similar tools</li>
          </ul>

          <h3>1.3 Information from third parties</h3>
          <p>We may receive information from:</p>
          <ul>
            <li>Analytics tools such as Google Analytics</li>
            <li>Payment providers when you pay for a program</li>
            <li>Social / identity providers if you log in through them</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and manage our drone education programs and services</li>
            <li>Respond to enquiries and provide customer support</li>
            <li>Improve our website, content and user experience</li>
            <li>Send updates, announcements and relevant communication</li>
            <li>Monitor usage to maintain security and prevent misuse</li>
          </ul>
          <p>
            You may opt out of marketing communications at any time by using the
            unsubscribe link in our emails or by writing to{" "}
            <a href="mailto:contact@pracverse.com">contact@pracverse.com</a>.
          </p>

          <h2>3. Sharing of Information</h2>
          <p>We do not sell your personal information.</p>
          <p>We may share information only with:</p>
          <ul>
            <li>
              <strong>Service providers</strong> who help us host the website,
              process payments, send emails or analyse usage.
            </li>
            <li>
              <strong>Partner schools or organisations</strong> when necessary
              for program coordination and only with appropriate consent.
            </li>
            <li>
              <strong>Authorities or regulators</strong> when required by law or
              to protect our legal rights.
            </li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We use reasonable technical and organisational measures to protect
            your data, including secure connections (HTTPS) and restricted access
            to systems. However, no system is completely secure and we cannot
            guarantee absolute security.
          </p>

          <h2>5. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction or deletion of your data</li>
            <li>Withdraw consent where processing is based on consent</li>
            <li>Object to or restrict certain types of processing</li>
          </ul>
          <p>
            To exercise these rights, contact us at{" "}
            <a href="mailto:contact@pracverse.com">contact@pracverse.com</a>.
          </p>

          <h2>6. Children&apos;s Privacy</h2>
          <p>
            Our programs are delivered primarily through schools and educational
            institutions. We collect information about students only with the
            involvement of their school and, where applicable, parents or
            guardians. Student data is used solely for educational and
            administrative purposes.
          </p>

          <h2>7. Data Retention</h2>
          <p>
            We retain personal data only for as long as needed to provide our
            services, comply with legal obligations, resolve disputes and enforce
            our agreements. When data is no longer required, we delete or
            anonymise it.
          </p>

          <h2>8. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites or services.
            Their privacy practices are not controlled by us, and we encourage
            you to review their policies separately.
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will
            be posted on this page with an updated &quot;Last updated&quot; date.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or how we handle
            your data, please contact us at:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:contact@pracverse.com">contact@pracverse.com</a>
            <br />
            <strong>Website:</strong> www.pracverse.com
          </p>
        </div>
      </section>
    </main>
    </>
  );
}
